import './home.scss';

function Home(){

    
    return (
        <section id="home">
            <div className="title fs-25">
                <h1><p>Philippe</p> <p>GENOT</p></h1>
            </div>
            <div className="title-logo-wrapper">
                <img src="/img/icons/logo-philippe.png" className="title-logo-mobile" />
            </div>
            <section id="me">
                <p className="work fs-40"></p>
                <p className="text qualities text-blue fs-25"></p>
            </section>
            <section className="flex-wrap buttonss">
                <a href="#projects" id="projects-btn" className="goContact">Mes projets</a>
                <a href="#infos" className="comeSee pulse">
                <p> V </p>
                </a>
                <a href="#contact" id="recruit" className="goContact">Me recruter</a>
            </section>
        </section>
  );
};
export default Home